import { render, staticRenderFns } from "./CRMCreateRequest.vue?vue&type=template&id=885f6be8&scoped=true"
import script from "./CRMCreateRequest.vue?vue&type=script&lang=js"
export * from "./CRMCreateRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885f6be8",
  null
  
)

export default component.exports